<template>
  <div
    class="wrapper"
    :class="{ imTrainingsmodus: trainingsmodusMitBluetooth !== null }"
  >
    <div>
      <TrainingsmodusModalComponent
        v-if="showTrainingsmodusModal"
        @navigateTo="stopTraining"
        @setzeTrainingsmodus="setzeTrainingsmodus"
      ></TrainingsmodusModalComponent>

      <CountdownOverlayComponent
        :visible="showCountdown"
        :duration="countdownSekunden"
        :play-sound="countdownSound"
        @countdown-finished="startTraining"
      />

      <EinstellungenModalComponent
        v-if="showEinstellungenModal"
        v-model:motivierendeNachrichten="motivierendeNachrichten"
        v-model:dynamicSpeed="dynamicSpeed"
        v-model:baseSpeedInVideo="baseSpeedInVideo"
        :videoUrl="videoUrl"
        :trainingsmodusMitBluetooth="trainingsmodusMitBluetooth"
        @close="showEinstellungenModal = !showEinstellungenModal"
      ></EinstellungenModalComponent>

      <ConfirmModalComponent
        ref="confirmDialog"
        title="Training beenden"
        :message="
          'Möchtest Du Dein Training wirklich beenden? ' +
          (distance < 100
            ? 'Du hast weniger als 100m Distanz zurückgelegt. Die Trainingsdaten werden nicht gespeichert.'
            : '')
        "
        @cancel="continueTraining"
        @confirm="stopTraining"
      ></ConfirmModalComponent>

      <!-- GUI -->
      <div
        class="table-overlay"
        id="draggable"
        ref="tableOverlayDraggable"
        :class="tableOverlayDisplayClass"
        :style="{
          minWidth:
            (device || trainingsmodusMitBluetooth === false) && !statsCollapsed
              ? '22rem'
              : '0',
        }"
      >
        <div
          id="drag-handler"
          :style="{
            display:
              device || trainingsmodusMitBluetooth === false ? 'block' : 'none',
            width: statsCollapsed ? '3.4rem' : '100%',
            overflow: 'hidden',
          }"
          style="
            cursor: move;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          "
        ></div>

        <!-- Progress Bar -->
        <div
          v-if="
            (device || trainingsmodusMitBluetooth === false) && !statsCollapsed
          "
          class="progress-container"
        >
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :style="{ width: progressPercentage + '%' }"
              :aria-valuenow="progressPercentage"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
          <!-- Der Text wird über die gesamte Breite zentriert -->
          <div class="progress-text">
            {{ formatDistance(currentDistance) }} /
            {{ formatDistance(totalDistance) }}
          </div>
        </div>

        <!-- Tabelle mit Stats -->
        <table
          v-if="
            (device || trainingsmodusMitBluetooth === false) && !statsCollapsed
          "
          class="table table-sm text-white"
        >
          <thead>
            <tr>
              <th>
                <span class="material-symbols-outlined" title="Speed"
                  >speed</span
                >
              </th>
              <th>
                <span class="material-symbols-outlined" title="Remaining"
                  >track_changes</span
                >
              </th>
              <th>
                <span class="material-symbols-outlined" title="Elapsed Time"
                  >schedule</span
                >
              </th>
              <th>
                <span class="material-symbols-outlined" title="In Motion Time"
                  >update</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="d-flex">
                  <span class="me-1">{{
                    Number(currentSpeedInKmH).toFixed(2)
                  }}</span>
                  <span>km/h</span>
                </div>
              </td>
              <td>
                <div class="d-flex">
                  {{ formatDistance(remainingDistance) }}
                </div>
              </td>
              <td>
                <div>{{ formattedElapsedTime }}</div>
              </td>
              <td>
                <div>{{ formattedInMotionTime }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between mt-2">
          <button
            v-if="device || trainingsmodusMitBluetooth === false"
            type="button"
            class="btn btn-light me-2"
            @click="statsCollapsed = !statsCollapsed"
          >
            <span
              v-if="statsCollapsed"
              class="material-symbols-outlined d-flex align-self-center"
              >expand_more</span
            >
            <span
              v-if="!statsCollapsed"
              class="material-symbols-outlined d-flex align-self-center"
              >expand_less</span
            >
          </button>
          <button
            v-if="
              (device || trainingsmodusMitBluetooth === false) &&
              !statsCollapsed
            "
            type="button"
            class="btn btn-light me-2"
            @click="showEinstellungenModal = true"
          >
            <span class="material-symbols-outlined d-flex align-self-center"
              >settings</span
            >
          </button>
          <button
            v-if="
              (device || trainingsmodusMitBluetooth === false) &&
              !statsCollapsed
            "
            type="button"
            class="btn btn-light me-2"
            @click="toggleFullscreen"
          >
            <span
              v-if="!isFullscreen"
              class="material-symbols-outlined d-flex align-self-center"
              >fullscreen</span
            >
            <span
              v-if="isFullscreen"
              class="material-symbols-outlined d-flex align-self-center"
              >fullscreen_exit</span
            >
          </button>
          <button
            v-if="!statsCollapsed"
            type="button"
            class="btn btn-outline-ruderclub-orange me-2"
            @click="showConfirmDialog('TrainingVideoDashboardView')"
          >
            <span class="d-flex align-items-center" title="Training beenden">
              <span class="material-symbols-outlined me-2">stop_circle</span>
              Dashboard
            </span>
          </button>
        </div>
      </div>

      <!-- Player -->
      <div id="player-container">
        <iframe
          id="player"
          :src="
            'https://www.youtube.com/embed/' + videoId + '?enablejsapi=1&rel=0'
          "
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { notify } from "@kyvg/vue3-notification";
import { firebaseAuth, firebaseDb } from "@/main";
import interact from "interactjs";
import TrainingsmodusModalComponent from "@/components/Training/TrainingsmodusModalComponent.vue";
import EinstellungenModalComponent from "@/components/Training/EinstellungenModalComponent.vue";
import ConfirmModalComponent from "@/components/Shared/ConfirmModalComponent.vue";
import CountdownOverlayComponent from "@/components/Training/CountdownOverlayComponent.vue";
import countdownOverlayComponent from "@/components/Training/CountdownOverlayComponent.vue";
import { doc, getDoc } from "firebase/firestore";

export default {
  components: {
    ConfirmModalComponent,
    EinstellungenModalComponent,
    TrainingsmodusModalComponent,
    CountdownOverlayComponent,
  },
  props: [
    "id",
    "videoUrl",
    "videoId",
    "baseSpeed",
    "videobeginn",
    "videodauer",
    "videotitel",
    "trainingsmethode",
  ],
  data() {
    return {
      benutzer: null,
      // Trainingsmodus
      showTrainingsmodusModal: true,
      trainingsmodusMitBluetooth: null,
      speedDataOhneBluetoothInterval: null,
      // Einstellungen
      showEinstellungenModal: false,
      motivierendeNachrichten: true,
      dynamicSpeed: true,
      baseSpeedInVideo: 0,
      // Hersteller
      geraetehersteller: {
        sportstech: {
          /**
           * Hinweis: Scheinbar senden alle Sportstech-
           * Geräte mit den gleichen uuids, weshalb
           * eine Unterscheidung nicht notwendig ist.
           */
          ergometer: {
            fx150: {
              services: [
                {
                  uuid: "00001826-0000-1000-8000-00805f9b34fb",
                  characteristics: [
                    {
                      uuid: "00002ace-0000-1000-8000-00805f9b34fb",
                      bemerkung: "Cadence & Speed",
                      cadenceUint16ByteOffset: 2,
                    },
                    {
                      uuid: "00002ad2-0000-1000-8000-00805f9b34fb",
                      bemerkung: "Cadence & Speed",
                      cadenceUint16ByteOffset: 2,
                    },
                  ],
                },
              ],
            },
          },
        },
      },
      // Countdown
      showCountdown: false,
      guiPosition: {
        x: null,
        y: null,
      },
      isFullscreen: false,
      iframe: null,
      player: null,
      device: null,
      currentSpeedInKmH: 0,
      distance: 0, // Meter
      startTime: null,
      elapsedTime: 0,
      inMotionTime: 0,
      lastUpdateTime: null,
      statsCollapsed: false,
      videoPlaying: false,
      notifiedThresholds: [], // Um bereits angezeigte Nachrichten zu speichern
      stopTrainingTargetComponentName: null,
    };
  },
  async mounted() {
    const userDocRef = doc(
      firebaseDb,
      "benutzer",
      firebaseAuth.currentUser.uid
    );
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      console.log("Nutzer konnte nicht geladen werden: ", userDocSnap);

      return;
    }

    this.benutzer = userDocSnap.data();
  },
  beforeUnmount() {
    this.stopSpeedDataOhneBluetoothInterval();
  },
  computed: {
    tableOverlayDisplayClass() {
      return this.showCountdown === true ? "d-none" : "d-inline";
    },
    countdownSekunden() {
      return this.benutzer ? this.benutzer.countdownSekunden : 0;
    },
    countdownSound() {
      return this.benutzer ? this.benutzer.countdownSound : 0;
    },
    countdownOverlayComponent() {
      return countdownOverlayComponent;
    },
    formattedElapsedTime() {
      return new Date(this.elapsedTime * 1000).toISOString().substr(11, 8);
    },
    formattedInMotionTime() {
      return new Date(this.inMotionTime * 1000).toISOString().substr(11, 8);
    },
    // Gesamtstrecke in Metern
    totalDistance() {
      const dauerInSekunden = this.timeToSeconds(this.videodauer);
      const beginnNachSekunden = this.timeToSeconds(this.videobeginn) || 0;
      const durationInSeconds = dauerInSekunden - beginnNachSekunden;

      return (this.baseSpeedInVideo * 1000 * durationInSeconds) / 3600;
    },
    // Aktuell zurückgelegte Strecke in Metern
    currentDistance() {
      return this.trainingsmodusMitBluetooth
        ? this.distance / 10
        : this.distance;
    },
    // Übrige Strecke in Metern
    remainingDistance() {
      return Math.max(this.totalDistance - this.currentDistance, 0);
    },
    // Fortschritt in Prozent
    progressPercentage() {
      return Math.min(
        (this.currentDistance / this.totalDistance) * 100,
        100
      ).toFixed(2);
    },
  },
  watch: {
    // Überwache den Fortschritt und überprüfe, ob eine Schwelle erreicht wurde
    progressPercentage(newPercentage) {
      if (this.motivierendeNachrichten) {
        this.checkThresholds(newPercentage);
      }
    },
  },
  methods: {
    dragMoveListener(event) {
      this.guiPosition.x += event.dx;
      this.guiPosition.y += event.dy;

      event.target.style.transform = `translate(${this.guiPosition.x}px, ${this.guiPosition.y}px)`;
    },

    setzeTrainingsmodus(mitBluetooth) {
      this.showTrainingsmodusModal = false;
      this.trainingsmodusMitBluetooth = mitBluetooth;

      if (!this.trainingsmodusMitBluetooth) {
        this.dynamicSpeed = false;
      }

      if (this.benutzer.countdownSekunden > 0) {
        this.showCountdown = true;
      } else {
        this.startTraining();
      }
    },

    startTraining() {
      this.showCountdown = false;

      this.baseSpeedInVideo = this.baseSpeed;

      this.connectToErgometerAndInitVideo();

      interact(this.$refs.tableOverlayDraggable).draggable({
        inertia: true,
        allowFrom: "#drag-handler",
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: true,
          }),
        ],
        listeners: {
          move: this.dragMoveListener,
        },
      });
    },

    formatDistance(meters) {
      const kilometers = (meters / 1000).toFixed(3).replace(".", ",");

      return `${kilometers}km`;
    },
    // Überprüfung, ob ein Schwellenwert erreicht wurde
    checkThresholds(percentage) {
      const thresholds = [
        {
          value: 25,
          message: () =>
            `Die ersten 25% (${this.formatDistance(
              this.currentDistance
            )}) geschafft!`,
        },
        {
          value: 33.3,
          message: () =>
            `Das erste Drittel (${this.formatDistance(this.currentDistance)}).`,
        },
        {
          value: 50,
          message: () =>
            `50% (${this.formatDistance(
              this.currentDistance
            )}) sind geschafft.`,
        },
        {
          value: 66.6,
          message: () =>
            `Nur noch 1/3 (${this.formatDistance(
              this.remainingDistance
            )}) übrig!`,
        },
        {
          value: 75,
          message: () =>
            `Die letzten 25% (${this.formatDistance(this.remainingDistance)}).`,
        },
        {
          value: 90,
          message: () =>
            `Nur noch 10% (${this.formatDistance(
              this.remainingDistance
            )}) zum Ziel!`,
        },
        {
          value: 100,
          message: () => {
            const messages = [
              "Großartig gemacht! Weiter so!",
              "Du bist ein Champion! 💪",
              "Super Leistung! Jede Anstrengung zählt!",
              "Klasse! Du hast es geschafft!",
              "Unglaublich! Du übertriffst dich selbst!",
              "Starke Leistung! Noch ein Schritt näher am Ziel!",
              "Fantastisch! Dein Einsatz zahlt sich aus!",
              "Du bist auf dem richtigen Weg. Weiter so!",
              "Glückwunsch! Ein großer Schritt nach vorne!",
              "Hervorragend! Du rockst das!",
            ];

            // Zufällige Erfolgsmeldung zurückgeben
            return messages[Math.floor(Math.random() * messages.length)];
          },
        },
      ];

      thresholds.forEach((threshold) => {
        if (
          percentage >= threshold.value &&
          !this.notifiedThresholds.includes(threshold.value)
        ) {
          notify({
            title: "Info",
            text: threshold.message(),
            type: "info",
            duration: 5000,
          });

          // Schwellenwert als "benachrichtigt" markieren
          this.notifiedThresholds.push(threshold.value);
        }
      });
    },
    showConfirmDialog(stopTrainingTargetComponentName) {
      if (this.speedDataOhneBluetoothInterval) {
        this.stopSpeedDataOhneBluetoothInterval();
        this.speedDataOhneBluetoothInterval = null;
      }

      this.currentSpeedInKmH = 0;
      this.pauseVideo();

      this.stopTrainingTargetComponentName = stopTrainingTargetComponentName;
      this.$refs.confirmDialog.show();
    },
    async continueTraining() {
      if (!this.speedDataOhneBluetoothInterval) {
        this.speedDataOhneBluetoothInterval = setInterval(
          this.handleSpeedDataOhneBluetooth,
          1000
        );
      }

      this.playVideo();
    },
    async stopTraining(targetComponentName = null) {
      if (this.trainingsmodusMitBluetooth) {
        await this.disconnectErgometer();
      }

      if (this.isFullscreen) {
        // End Fullscreen
        this.toggleFullscreen();
      }

      if (this.iframe) {
        this.stopVideo();
      }

      const form = {
        benutzer: firebaseAuth.currentUser.uid,
        titel: this.videotitel,
        trainingsmethode: this.trainingsmethode,
        datumUhrzeit: new Date().toISOString().slice(0, 16),
        distanz: parseInt(
          this.trainingsmodusMitBluetooth ? this.distance / 10 : this.distance
        ),
        dauer: new Date(this.inMotionTime * 1000).toISOString().substr(11, 8),
      };

      if (!this.trainingsmodusMitBluetooth) {
        this.stopSpeedDataOhneBluetoothInterval();
      }

      if (form.benutzer && form.distanz >= 100) {
        this.$root.$refs.trainingseinheitAnlegenModal.open(
          form,
          this.stopTrainingTargetComponentName
        );

        return;
      }

      this.$router.push({
        name: targetComponentName ?? this.stopTrainingTargetComponentName,
      });
    },
    timeToSeconds(time) {
      const parts = time.split(":").map(Number).reverse();
      let seconds = 0;
      if (parts[0]) seconds += parts[0]; // Sekunden
      if (parts[1]) seconds += parts[1] * 60; // Minuten
      if (parts[2]) seconds += parts[2] * 3600; // Stunden

      return seconds;
    },
    async disconnectErgometer() {
      if (!this.device) {
        return;
      }

      if (this.device.gatt.connected) {
        this.device.gatt.disconnect();
      }

      this.device = null;
    },
    stopSpeedDataOhneBluetoothInterval() {
      if (this.speedDataOhneBluetoothInterval !== null) {
        clearInterval(this.speedDataOhneBluetoothInterval);
        this.speedDataOhneBluetoothInterval = null;
      }
    },
    async connectToErgometerAndInitVideo() {
      try {
        if (this.trainingsmodusMitBluetooth) {
          this.device = await navigator.bluetooth.requestDevice({
            acceptAllDevices: true,
            optionalServices:
              this.geraetehersteller.sportstech.ergometer.fx150.services.map(
                (service) => service.uuid
              ),
          });
        }

        this.initVideo();

        if (!this.trainingsmodusMitBluetooth) {
          if (!this.speedDataOhneBluetoothInterval) {
            this.speedDataOhneBluetoothInterval = setInterval(
              this.handleSpeedDataOhneBluetooth,
              1000
            );
          }

          return;
        }

        const server = await this.device.gatt.connect();

        if (!server) {
          notify({
            title: "GATT Error: Not supported",
            text:
              "Ist Dein Gerät evtl. im Standby-Modus? " +
              "Navigiere zurück auf's Dashboard, wecke Dein Gerät auf und versuche es noch einmal.",
            type: "error",
            duration: 5000,
          });

          return;
        }

        for (const geraeteherstellerService of this.geraetehersteller.sportstech
          .ergometer.fx150.services) {
          try {
            const service = await server.getPrimaryService(
              geraeteherstellerService.uuid
            );
            const characteristics = await service.getCharacteristics();

            for (const characteristic of characteristics) {
              try {
                const konkreteCharacteristic = await service.getCharacteristic(
                  characteristic.uuid
                );

                if (konkreteCharacteristic) {
                  if (
                    typeof konkreteCharacteristic.startNotifications ===
                    "function"
                  ) {
                    try {
                      const eventSender =
                        await konkreteCharacteristic.startNotifications();
                      eventSender.addEventListener(
                        "characteristicvaluechanged",
                        this.handleSpeedDataMitBluetooth
                      );
                    } catch (err) {
                      console.warn(
                        `Failed to start notifications for characteristic ${characteristic.uuid}:`,
                        err
                      );
                    }
                  } else {
                    console.info(
                      `Characteristic ${characteristic.uuid} does not support notifications.`
                    );
                  }
                }
              } catch (err) {
                console.warn(
                  `Error processing characteristic ${characteristic.uuid}:`,
                  err
                );
              }
            }
          } catch (err) {
            console.error(
              `Error processing service ${geraeteherstellerService.uuid}:`,
              err
            );
          }
        }
      } catch (error) {
        const errorTitle = "Verbindung zum Ergometer fehlgeschlagen";
        const errorMessage = error.message;

        notify({
          title: errorTitle,
          text: errorMessage,
          type: "error",
          duration: 5000,
        });

        console.error(errorTitle + ": " + error);
      }
    },
    initVideo() {
      this.iframe = document.getElementById("player");

      if (this.videobeginn && this.videobeginn !== "00:00:00") {
        this.seekToPosition(this.videobeginn);
      }

      this.playVideo();
      this.startTime = Date.now();
      this.lastUpdateTime = Date.now();
      this.updateElapsedTime();
    },
    sendMessageToPlayer(command, args) {
      const message = {
        event: "command",
        func: command,
        args: args ? (Array.isArray(args) ? args : [args]) : [],
      };

      const iframe = document.getElementById("player");
      iframe.contentWindow.postMessage(JSON.stringify(message), "*");
    },
    handleSpeedDataOhneBluetooth() {
      if (!this.baseSpeedInVideo) {
        alert("No baseSpeed!");
        return;
      }

      this.currentSpeedInKmH = this.baseSpeedInVideo;
      this.handleSpeedData();
    },
    handleSpeedDataMitBluetooth(event) {
      const speedRaw = event.target.value.getUint16(2, true);
      this.currentSpeedInKmH = speedRaw * 0.01;
      this.handleSpeedData();
    },
    handleSpeedData() {
      if (this.currentSpeedInKmH > 0) {
        // Zeitdifferenz in Sekunden
        const timeDeltaInSeconds = (Date.now() - this.lastUpdateTime) / 1000;

        // Konvertiere Geschwindigkeit von km/h in m/s
        const speedInMetersPerSecond = this.currentSpeedInKmH * (1000 / 3600);

        this.distance += speedInMetersPerSecond * timeDeltaInSeconds;
        this.inMotionTime += timeDeltaInSeconds;

        if (!this.videoPlaying) {
          this.playVideo();
        }

        if (this.dynamicSpeed) {
          const playbackRate = this.currentSpeedInKmH / this.baseSpeedInVideo;

          if (this.iframe) {
            this.setPlaybackRate(playbackRate);
          }
        }
      } else {
        this.pauseVideo();
      }

      this.lastUpdateTime = Date.now();
    },
    updateElapsedTime() {
      setInterval(() => {
        this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000);
      }, 1000);
    },
    toggleFullscreen() {
      if (this.isFullscreen) {
        // Aus dem Fullscreen-Modus wechseln
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.isFullscreen = false;
        } else if (document.webkitExitFullscreen) {
          // Safari
          document.webkitExitFullscreen();
          this.isFullscreen = false;
        } else if (document.msExitFullscreen) {
          // IE/Edge
          document.msExitFullscreen();
          this.isFullscreen = false;
        } else {
          notify({
            title: "Hoppla.",
            text: "Fullscreen-Modus kann nicht verlassen werden.",
            type: "error",
            duration: 5000,
          });
        }

        return;
      }

      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
        this.isFullscreen = true;
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
        this.isFullscreen = true;
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
        this.isFullscreen = true;
      } else {
        notify({
          title: "Hoppala",
          text: "Fullscreen wird in diesem Browser nicht unterstützt.",
          type: "error",
          duration: 5000,
        });
      }
    },
    playVideo() {
      if (this.videoPlaying) {
        return;
      }

      this.videoPlaying = true;
      this.sendMessageToPlayer("playVideo");
    },
    pauseVideo() {
      if (!this.videoPlaying) {
        return;
      }

      this.videoPlaying = false;
      this.sendMessageToPlayer("pauseVideo");
    },
    stopVideo() {
      this.videoPlaying = false;
      this.sendMessageToPlayer("stopVideo");
    },
    setPlaybackRate(rate) {
      this.sendMessageToPlayer("setPlaybackRate", rate);
    },
    seekToPosition(time) {
      this.sendMessageToPlayer("seekTo", [this.timeToSeconds(time), true]);
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100vw;
}

.wrapper.imTrainingsmodus {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}

.table-overlay {
  user-select: none;
  position: absolute;
  bottom: 10px; /* Abstand vom unteren Rand */
  left: 50%;
  transform: translateX(-50%); /* Exakte Zentrierung */
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  z-index: 1000;
}

@media (max-width: 480px) {
  /* Smartphone */
  .table-overlay {
    width: 100%; /* Volle Breite */
    border-radius: 0; /* Kein Rand für mobiles Design */
    left: 0;
    transform: none;
  }
}

#drag-handler {
  background: radial-gradient(circle, white 1px, transparent 2px);
  background-size: 6px 6px; /* Größe der Punkte & Abstand */
  background-repeat: repeat-x; /* Nur horizontal wiederholen */
  height: 1em; /* Passt sich der Schriftgröße an */
  line-height: 1em;
  white-space: nowrap;
}

thead > tr th {
  text-align: center;
}
#player-container {
  width: 100%;
  height: 100vh;
  position: relative;
}
#player {
  width: 100%;
  height: 100%;
  position: absolute;
}
/* Container für die Progressbar */
.progress-container {
  position: relative;
  width: 100%;
}
/* Progressbar */
.progress {
  height: 20px;
  position: relative;
  background-color: #e9ecef;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  overflow: hidden;
}
/* Fortschrittsbalken */
.progress-bar {
  background-color: #007bff;
  height: 100%;
  transition: width 0.4s ease;
}
/* Zentrierter Text */
.progress-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; /* Nimmt die gesamte Breite des Containers ein */
  height: 100%; /* Passt sich der Höhe der Progressbar an */
  display: flex;
  align-items: center; /* Vertikale Zentrierung */
  justify-content: center; /* Horizontale Zentrierung */
  color: black; /* Farbe des Textes */
  font-weight: bold;
  pointer-events: none; /* Damit der Text nicht den Progressbar stört */
}
</style>
